export default "__VITE_ASSET__BTfflpt0__"